import { post } from 'lib/api';
import { useMutation } from '@tanstack/react-query';

const postForgotPassword = async (fields) => {
  const data = await post('auth/forgot', {
    username: fields.username
  });

  return data;
};

export function useUserForgotPassword() {
  return useMutation({
    mutationFn: postForgotPassword
  });
}
